export default __webpack_public_path__ + "static/create-branch-4ab7aedeac0a896b7fbcc334b093378c.png";